// app/javascript/controllers/chatra_controller.js
import { Controller } from "@hotwired/stimulus"
import Chatra from '@chatra/chatra'

export default class extends Controller {
  connect() {
    this.initChatra()
    
    // Listen for Turbo navigation events
    document.addEventListener("turbo:visit", this.resetChatra.bind(this))
    document.addEventListener("turbo:load", this.initChatra.bind(this))
  }
  
  disconnect() {
    // Clean up event listeners when controller disconnects
    document.removeEventListener("turbo:visit", this.resetChatra.bind(this))
    document.removeEventListener("turbo:load", this.initChatra.bind(this))
  }
  
  initChatra() {
    // Initialize Chatra if it's not already initialized or reinitialize after navigation
    let chat_config = {
      setup: {
        buttonSize: 50,
        colors: {
          buttonText: '#ffffff',
          buttonBg: '#CA3C5F'
        }
      },
      ID: '7aowCmfBcjkAdYS2R'
    }
    
    Chatra('init', chat_config)
  }
  
  resetChatra() {
    // You may need to clean up Chatra before a new page visit
    // Only if the Chatra API provides a cleanup method
    if (window.Chatra && typeof window.Chatra === 'function') {
      // If Chatra provides a reset or cleanup method, call it here
      // For example: Chatra('reset') or similar
    }
  }
}